export type PlayerColor = 'black' | 'white' | null

export type Direction =   
  [1, 0] |  // vertical
  [0, 1] |  // horizontal
  [1, 1] |  // diagonal \
  [1, -1]; // diagonal /

export interface BoardCell {
  value : PlayerColor;
}

export function playerColorToString(playerColor: PlayerColor): string {
  let color = '';
  if (playerColor === 'black' || playerColor === 'white') {
    color = playerColor;
  }
  return color;
}

export function stringToPlayerColor(playerColor: string): PlayerColor {
  let color: PlayerColor = null;
  if (playerColor === 'black' || playerColor === 'white') {
    color = playerColor;
  }
  return color;
}